import { render } from "./AffiliateWithdrawPromptModal.vue?vue&type=template&id=6c67a446&scoped=true"
import script from "./AffiliateWithdrawPromptModal.vue?vue&type=script&lang=js"
export * from "./AffiliateWithdrawPromptModal.vue?vue&type=script&lang=js"

import "./AffiliateWithdrawPromptModal.vue?vue&type=style&index=0&id=6c67a446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c67a446"]])

export default __exports__